const nonNumericPattern = /[a-zA-Z\ \%\,]*/g;

export function toDecimal(value: number) {
  return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export function fromDecimal(value: string) {
  return parseFloat(value.replace(nonNumericPattern, ''));
}
